import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Sidebar from "../../components/common/Sidebar";
import Header from "../../components/common/Header";
import client from "../../services/Client";
import Loading from "../../components/loader/Loading";
import arrowLeft from "../../asessts/Images/arrow_left.svg";
import { formatRole } from "../../utils/common";
import ImagePreviewModal from "../../components/common/ImagePreviewModal";

const FacilityHospitalDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [hospitalData, setHospitalData] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);

  const fetchHospitalDetail = async () => {
    setIsLoading(true);
    try {
      const response = await client.get(
        `/admin/healthFacility/get-hospital/${id}`
      );
      setHospitalData(response?.data?.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching hospital details:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchHospitalDetail();
    }
  }, [id]);

  return (
    <>
      <div className="admin-dashboard">
        <Sidebar />
        <div className="main-dashboard subadmin-dashboard">
          <Header
            title={
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <img
                  src={arrowLeft}
                  alt="Back"
                  style={{ cursor: "pointer", width: "22px", height: "22px" }}
                  onClick={() => navigate(-1)}
                />
                <span>Hospital Details</span>
              </div>
            }
          />
          {isLoading ? (
            <Loading />
          ) : (
            <div>
              <div className="setting-main request-main">
                <div className="setting-details">
                  <div className="basic-detail">
                    <div className="profile-upload">
                      <div className="profile-img">
                        <img src={hospitalData?.information?.image} alt="" />
                      </div>
                    </div>
                    <div className="profile-details">
                      <div className="profile-head">
                        <div>
                          <h2>
                            {hospitalData?.user?.firstName}
                            {hospitalData?.user?.lastName}
                          </h2>
                          <p>
                            <span>Profile ID:</span> {hospitalData?.profileId}
                          </p>
                        </div>
                      </div>
                      <div className="input-group">
                        <div className="input-field">
                          <label>Type</label>
                          <input
                            type="text"
                            placeholder="Type"
                            value={
                              formatRole(hospitalData.facilityOrProfession) ||
                              "--"
                            }
                            readOnly
                          />
                        </div>
                        <div className="input-field">
                          <label>Role</label>
                          <input
                            type="text"
                            placeholder="role"
                            value={formatRole(hospitalData.role) || "--"}
                            readOnly
                          />
                        </div>
                        <div className="input-field">
                          <label>Phone Number</label>
                          <input
                            type="text"
                            placeholder="Phone"
                            value={
                              hospitalData?.user?.phoneNumber
                                ? `+${hospitalData.user.phoneNumber.dialCode} ${hospitalData.user.phoneNumber.number}`
                                : "--"
                            }
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="input-group">
                        <div className="input-field">
                          <label>Email</label>
                          <input
                            type="text"
                            placeholder="Email"
                            value={
                              hospitalData?.email ||
                              hospitalData?.user?.email ||
                              "--"
                            }
                            readOnly
                          />
                        </div>
                        <div className="input-field">
                          <label>Address</label>
                          <textarea
                            className="input-address"
                            placeholder="Address"
                            value={
                              hospitalData?.information?.address.add || "--"
                            }
                            readOnly
                          />
                        </div>
                        <div className="input-field">
                          {/* <label>Registration Number</label>
                        <input
                          type="text"
                          placeholder="Registration"
                          value={
                            hospitalData?.information?.registrationNumber ||
                            "--"
                          }
                          readOnly
                        /> */}
                        </div>
                      </div>
                      <div className="input-group">
                        {hospitalData?.information?.additionalText && (
                          <div className="input-field" style={{ width: "48%" }}>
                            <label>Additional Text</label>
                            <textarea
                              placeholder="Description"
                              value={
                                hospitalData?.information?.additionalText ||
                                "--"
                              }
                              readOnly
                            ></textarea>
                          </div>
                        )}
                        {hospitalData?.specializations && (
                          <div className="input-field" style={{ width: "48%" }}>
                            <label>Specializations</label>
                            <textarea
                              placeholder="Specializations"
                              value={hospitalData?.specializations?.join(", ")}
                              readOnly
                            ></textarea>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {hospitalData?.documents && (
                <div class="request-document">
                  <h3>Professional Documents</h3>
                  <div class="doc-main">
                    <div>
                      {hospitalData?.documents?.certificate && (
                        <div class="doc">
                          <div
                            class="doc-file"
                            onClick={() =>
                              setSelectedImage(
                                hospitalData?.documents?.certificate
                              )
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={hospitalData?.documents?.certificate}
                              alt=""
                            />
                          </div>
                          <div class="Document-name">
                            <span>
                              {hospitalData?.documents &&
                              Object.keys(hospitalData.documents).length > 0
                                ? Object.keys(hospitalData.documents)[0]
                                : "No document available"}
                            </span>
                          </div>
                        </div>
                      )}
                      {hospitalData?.documents?.license !== "" ? (
                        <div class="doc">
                          <div
                            class="doc-file"
                            onClick={() =>
                              setSelectedImage(hospitalData?.documents?.license)
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={hospitalData?.documents?.license}
                              alt=""
                            />
                          </div>
                          <div class="Document-name">
                            <span>
                              {hospitalData?.documents &&
                              Object.keys(hospitalData.documents).length > 0
                                ? Object.keys(hospitalData.documents)[1]
                                : "No document available"}
                            </span>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              )}

              {hospitalData?.personalDocuments && (
                <div className="request-document">
                  <h3>Personal Documents</h3>
                  <div className="doc-main">
                    <div>
                      {hospitalData?.personalDocuments?.nimc && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(
                                hospitalData?.personalDocuments?.nimc
                              )
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={hospitalData?.personalDocuments?.nimc}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>NIMC</span>
                          </div>
                        </div>
                      )}
                      {hospitalData?.personalDocuments?.license && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(
                                hospitalData?.personalDocuments?.license
                              )
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={hospitalData?.personalDocuments?.license}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>License</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {hospitalData?.otherServices && (
                <div className="request-document">
                  <h4>Other Services</h4>
                  <div className="other-services-container">
                    {hospitalData?.otherServices?.map((service, index) => (
                      <div className="service-card" key={index}>
                        {service}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {hospitalData?.insurances && (
                <div className="request-document-other">
                  <h4>Insurances</h4>
                  <div className="other-services-container">
                    {hospitalData?.insurances?.map((item, index) => (
                      <div className="service-card" key={index}>
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {hospitalData?.doctor && (
                <div className="request-document-other">
                  <h4>Doctors</h4>
                  <div className="other-services-container doctors-list-data">
                    {hospitalData?.doctor?.map((doc, index) => (
                      <div className="service-card" key={index}>
                        <div
                          style={{
                            fontSize: "14px",
                            color: "#d58de8",
                            fontWeight: "500",
                          }}
                        >
                          {doc.speciality}
                        </div>
                        <div
                          className="second"
                          style={{
                            fontWeight: "600",
                            marginTop: "4px",
                            fontSize: "20.98px",
                          }}
                        >
                          {doc.name}
                        </div>
                        {doc?.schedule && doc.schedule.length > 0 && (
                          <div
                            className="doctors-details"
                            style={{ marginTop: "12px" }}
                          >
                            <h5
                              style={{ fontSize: "16px", marginBottom: "6px" }}
                            >
                              Schedule
                            </h5>
                            <div className="doc-main">
                              <div
                                className="doc d-flex justify-content-between py-0"
                                style={{ width: "100%" }}
                              >
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Time</th>
                                      <th>Days Available</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {doc.schedule.map((slot, sIndex) => (
                                      <tr key={sIndex}>
                                        <td>
                                          {slot?.startTime} - {slot?.endTime}
                                        </td>
                                        <td>{slot?.days?.join(", ")}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {hospitalData?.professionalDocuments && (
                <div className="request-document">
                  <h3>Professional Documents</h3>
                  <div className="doc-main">
                    <div>
                      {hospitalData?.professionalDocuments?.certificate && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(
                                hospitalData?.professionalDocuments?.certificate
                              )
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={
                                hospitalData?.professionalDocuments?.certificate
                              }
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>
                              {hospitalData?.professionalDocuments &&
                              Object.keys(hospitalData.professionalDocuments)
                                .length > 0
                                ? Object.keys(
                                    hospitalData.professionalDocuments
                                  )[0]
                                : "No document available"}
                            </span>
                          </div>
                        </div>
                      )}
                      {hospitalData?.professionalDocuments?.license && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(
                                hospitalData?.professionalDocuments?.license
                              )
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={hospitalData?.professionalDocuments?.license}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>
                              {hospitalData?.professionalDocuments &&
                              Object.keys(hospitalData.professionalDocuments)
                                .length > 1
                                ? Object.keys(
                                    hospitalData.professionalDocuments
                                  )[1]
                                : "No document available"}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {hospitalData?.personalDocuments && (
                <div className="request-document">
                  <h3>Personal Documents</h3>
                  <div className="doc-main">
                    <div>
                      {hospitalData?.personalDocuments?.nimc && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(
                                hospitalData?.personalDocuments?.nimc
                              )
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={hospitalData?.personalDocuments?.nimc}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>NIMC</span>
                          </div>
                        </div>
                      )}
                      {hospitalData?.personalDocuments?.license && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(
                                hospitalData?.personalDocuments?.license
                              )
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={hospitalData?.personalDocuments?.license}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>License</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      {selectedImage && (
        <ImagePreviewModal
          imageUrl={selectedImage}
          onClose={() => setSelectedImage(null)}
        />
      )}
    </>
  );
};

export default FacilityHospitalDetail;
